import { Controller } from 'stimulus';
import Sortable from 'sortablejs';

export default class extends Controller {
  connect() {
    const sortableContainer = document.getElementById('sortable-container');
    if (sortableContainer != null) {
      const sortable = Sortable.create(sortableContainer, {
        onEnd: () => this.updatePositionIndexes(),
      });
    }
  }

  saveForm() {
    $('#draft-submit').click();
  }

  updatePositionIndexes() {
    $('.j-card').each(function(index) {
      var ind = index + 1;
      var $element = $(this);
      $element.find('.position').val(ind);
    });
    this.saveForm();
  }

  moveCard(event) {
    event.preventDefault();
    const button = event.target.closest('.control[data-direction]');
    if (button) {
      const direction = button.dataset.direction;
      const card = button.closest('.j-card');
      const adjacentCard = this.getAdjacentCard(card, direction);

      if (adjacentCard) {
        if (direction === 'up') {
          card.parentNode.insertBefore(card, adjacentCard);
        } else if (direction === 'down') {
          card.parentNode.insertBefore(adjacentCard, card);
        }

        this.updatePositionIndexes();
      }
    }
  }

  getAdjacentCard(card, direction) {
    const siblingSelector = direction === 'up' ? 'previousElementSibling' : 'nextElementSibling';
    let adjacentElement = card[siblingSelector];

    while (adjacentElement && !adjacentElement.classList.contains('j-card')) {
      adjacentElement = adjacentElement[siblingSelector];
    }

    return adjacentElement;
  }
}
